import ResultOfferCard from './ResultOfferCard';
import { formatResultDate, locationCode } from '../../utils/resultDisplay';
import { SITE_NAME } from '../../constants/site';

export default function CarResultCard({ item, searchParams }) {
  const pickupCode = locationCode(item.pickup, 'CAR');
  const bookingLines = [
    { label: 'Vehicle', value: item.type },
    { label: 'Company', value: item.company },
    { label: 'Pick-up', value: item.pickup },
    { label: 'Total price', value: `$${item.price.toFixed(2)}` },
  ];

  return (
    <ResultOfferCard
      dateLabel={formatResultDate(searchParams?.get('pickupDate'))}
      providerName={`${item.type} — ${item.company}`}
      providerFallback={item.company?.slice(0, 2)?.toUpperCase()}
      routeLeft={{ code: pickupCode, time: 'Pick-up' }}
      routeRight={{ code: item.transmission?.slice(0, 3)?.toUpperCase() || 'AUTO', time: `${item.seats} seats` }}
      routeDuration={`${item.days || '—'} day rental`}
      routeStops={item.company}
      price={{ amount: item.perDay ?? item.price, currency: 'USD' }}
      pricePerLabel="Price per day"
      priceFinePrint={`Sample total $${Number(item.price).toFixed(2)} — not a live price`}
      detailsTitle="Rental Details"
      detailRows={[
        { label: 'Vehicle', value: item.type },
        { label: 'Company', value: item.company },
        { label: 'Pick-up', value: item.pickup },
      ]}
      bookNowProps={{
        serviceType: 'car',
        bookingPayload: {
          subject: `${SITE_NAME} — Car rental booking`,
          bookingLines,
          offer: {
            type: item.type,
            company: item.company,
            pickup: item.pickup,
            pickupDate: formatResultDate(searchParams?.get('pickupDate')),
            dropoffDate: formatResultDate(searchParams?.get('dropoffDate')),
            seats: item.seats,
            transmission: item.transmission,
          },
          price: {
            base: item.perDay ?? item.price,
            total: item.price,
            travelerLabel: '1 Rental',
          },
        },
      }}
    />
  );
}
